import React from 'react';
import styled from 'styled-components';
import bgbg from './bg6.jpg';
import {AiOutlineStock} from 'react-icons/ai'



const Stock = () =>{
    return(
        <Container>
            <Wrapper>
            <Hold2>
                <Div>
                    <H1>Stock</H1>
                    <Holder>
                        <Icon />
                        <Pagename>--What is Stock</Pagename>
                    </Holder>
                </Div>
            </Hold2>
        </Wrapper>
        <Down>
            <p>
                <H1>Why Invest in Stocks</H1>
                <br/>
                <br/>
        Growth potential While stock performance changes over time, successful stocks can help your money grow—at times, they can even outrun inflation
        Income Some stocks pay regular dividends—that’s income you can keep or reinvest
        Flexibility Since stocks trade by the millions every day, you can move quickly when you’re buying or selling
        Control You decide which company to invest in, when it’s time to buy, and when it’s time to sell
        Details on Stocks.
        <br/>
        WHAT IS A DIVIDEND?
        <br/>
        A dividend is a payment made by a corporation to its stockholders, usually out of its profits. Dividends are typically paid regularly (e.g. quarterly) and made as a fixed amount per share of stock.
        <br/>
        <br/>
        THE BASICS OF STOCK SELECTION:
        <br/>
        Selecting stocks for investing and trading should not be a guessing game in today's market. Join us as we review the basics of technical analysis and other stock selection techniques you should know before buying a stock.
        <br/>
        <br/>
        While stocks fluctuate, growth may help you keep ahead of inflation. Potentially generate income with dividends. 
        <span style={{color: "#CD4844"}}>Flexibility for long- and short-term investing strategies.</span> Placing a stock trade is about a lot more than pushing a button and entering your order. This brief video can help you prepare before you open a position and develop a plan for managing it.
        <br/>
        <br/>
        Stock trading broadly refers to any buying and selling of stock, but is colloquially used to refer to more shorter-term investments made by very active investors. Stock trading is a difficult and risky enterprise, but with education, you can work to lower risks and increase your likelihood of success.
        <br/>
        <br/>
        Stock speculators and investors usually need a stock broker such as a bank or a brokerage firm to access the stock market. Since the advent of Internet banking, an Internet connection is commonly used to manage positions. Using the Internet, specialized software, and a personal computer, stock speculators/investors make use of technical and fundamental analysis to help them in making decisions. They may use several information resources, some of which are strictly technical.
        <br/>
        <br/>
        Using the pivot points calculated from a previous day's trading, they attempt to predict the buy and sell points of the current day's trading session. These points give a cue to speculators, as to where prices will head for the day, prompting each speculator where to enter his trade, and where to exit. An added tool for the stock picker is the use of stock screens. Stock screens allow the user to input specific parameters, based on technical and/or fundamental conditions, that he or she deems desirable. Primary benefit associated with stock screens is its ability to return a small group of stocks for further analysis, among tens of thousands, that fit the requirements requested. There is criticism on the validity of using these technical indicators in analysis, and many professional stock speculators do not use them.
        </p>
        <br/>
        <br/>
        <Wrap2>
        <iframe title='btc' allowtransparency="true" frameborder="0" src="https://s.tradingview.com/embed-widget/mini-symbol-overview/?locale=en#%7B%22symbol%22%3A%22NASDAQ%3AAAPL%22%2C%22width%22%3A%22100%25%22%2C%22height%22%3A%22100%25%22%2C%22dateRange%22%3A%2212M%22%2C%22colorTheme%22%3A%22light%22%2C%22trendLineColor%22%3A%22rgba(41%2C%2098%2C%20255%2C%201)%22%2C%22underLineColor%22%3A%22rgba(41%2C%2098%2C%20255%2C%200.3)%22%2C%22underLineBottomColor%22%3A%22rgba(41%2C%2098%2C%20255%2C%200)%22%2C%22isTransparent%22%3Afalse%2C%22autosize%22%3Atrue%2C%22largeChartUrl%22%3A%22%22%2C%22utm_source%22%3A%22www.kryptbased-assets.com%22%2C%22utm_medium%22%3A%22widget%22%2C%22utm_campaign%22%3A%22mini-symbol-overview%22%2C%22page-uri%22%3A%22www.kryptbased-assets.com%2F%22%7D" style={{boxSizing: "border-box",display: "block", height: "100%", width: "100%"}}></iframe>
        <iframe title='eth' allowtransparency="true" frameborder="0" src="https://s.tradingview.com/embed-widget/mini-symbol-overview/?locale=en#%7B%22symbol%22%3A%22BINANCE%3ABTCUSDT%22%2C%22width%22%3A%22100%25%22%2C%22height%22%3A%22100%25%22%2C%22dateRange%22%3A%2212M%22%2C%22colorTheme%22%3A%22light%22%2C%22trendLineColor%22%3A%22rgba(41%2C%2098%2C%20255%2C%201)%22%2C%22underLineColor%22%3A%22rgba(41%2C%2098%2C%20255%2C%200.3)%22%2C%22underLineBottomColor%22%3A%22rgba(41%2C%2098%2C%20255%2C%200)%22%2C%22isTransparent%22%3Afalse%2C%22autosize%22%3Atrue%2C%22largeChartUrl%22%3A%22%22%2C%22utm_source%22%3A%22www.kryptbased-assets.com%22%2C%22utm_medium%22%3A%22widget%22%2C%22utm_campaign%22%3A%22mini-symbol-overview%22%2C%22page-uri%22%3A%22www.kryptbased-assets.com%2F%22%7D" style={{boxSizing: "border-box", display: "block", height: "100%", width: "100%"}}></iframe>
        <iframe title='alt' allowtransparency="true" frameborder="0" src="https://s.tradingview.com/embed-widget/mini-symbol-overview/?locale=en#%7B%22symbol%22%3A%22FX%3AEURUSD%22%2C%22width%22%3A%22100%25%22%2C%22height%22%3A%22100%25%22%2C%22dateRange%22%3A%2212M%22%2C%22colorTheme%22%3A%22light%22%2C%22trendLineColor%22%3A%22rgba(41%2C%2098%2C%20255%2C%201)%22%2C%22underLineColor%22%3A%22rgba(41%2C%2098%2C%20255%2C%200.3)%22%2C%22underLineBottomColor%22%3A%22rgba(41%2C%2098%2C%20255%2C%200)%22%2C%22isTransparent%22%3Afalse%2C%22autosize%22%3Atrue%2C%22largeChartUrl%22%3A%22%22%2C%22utm_source%22%3A%22www.kryptbased-assets.com%22%2C%22utm_medium%22%3A%22widget%22%2C%22utm_campaign%22%3A%22mini-symbol-overview%22%2C%22page-uri%22%3A%22www.kryptbased-assets.com%2F%22%7D" style={{boxSizing: "border-box", display: "block", height: "100%", width: "100%"}}></iframe>
        </Wrap2>
        </Down>
        </Container>
    )
};

export default Stock;

const Container = styled.div`
background-color: #16233C;
width :100%;
height: auto;
display: flex;
flex-direction: column;
align-items: center;
`;

const Wrapper = styled.div`
 width: 100%;
    height: 40vh;
    /* min-height: max-content; */
    background-image: url(${bgbg});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

@media Screen and (max-width: 768px){
    display: block;
    width: 100%;
    height: 40vh;
    /* min-height: max-content; */
    background-image: url(${bgbg});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
`;

const Hold2 = styled.div`
/* display: none; */
width: 100%;
    height: 40vh;
    background-color: #0F192C;
    opacity: 75%;
    display: flex;
    align-items:center;
@media Screen and (max-width: 768px){
    display: block;
    width: 100%;
    height: 40vh;
    background-color: #0F192C;
    opacity: 75%;
    display: flex;
    align-items:center;
}

`;

const Div = styled.div`
/* display: none; */
width: auto;
    height: auto;
    /* background-color: red; */
    margin-left: 180px;
@media Screen and (max-width: 768px){
    width: auto;
    height: auto;
    /* background-color: red; */
    margin-left: 80px;
}

`;
const H1 = styled.div`
font-size: 45px;
    color: whitesmoke;
    font-weight: bold;
@media Screen and (max-width: 768px){
    /* display: block; */
    font-size: 45px;
    color: whitesmoke;
    font-weight: bold;
}
`;
const Holder = styled.div`
display: block;
    width: auto;
    display: flex;
    align-items: center;

@media Screen and (max-width: 768px){
    display: block;
    width: auto;
    display: flex;
    align-items: center;
    /* justify-content: ; */
} 
`;
const Pagename = styled.div`
/* display: none; */
font-size: 25px;
color: #FF4D4D;
font-weight: bold;
display: block;
display: flex;
justify-content: flex-start;
@media Screen and (max-width: 768px){
font-size: 25px;
color: #FF4D4D;
font-weight: bold;
display: block;
display: flex;
justify-content: flex-start;
}
`;

const Icon = styled(AiOutlineStock)`
    color: #FF4D4D;
    width: 30px;
    height: 30px;

@media Screen and (max-width: 768px){
    /* display: block; */
    color: #FF4D4D;
    width: 30px;
    height: 30px;

}
`;

const Down = styled.div`
width: 80%;
height: auto;
display: flex;
flex-direction: column;


p{
    color: lightgrey;
}
`;

const Wrap2 = styled.div`
width: 100%;
height: auto;
margin: 35px 0;
display: flex;
justify-content: space-between;

@media Screen and (max-width: 768px){
    flex-direction: column;
    with: 100%;
    justify-content: center;
    align-items: center;
}


`;
